import {Link} from '@primer/react'
import {clsx} from 'clsx'
import {useSidebarActivityOpenTimeline} from './use-sidebar-activity-open-timeline'
import styles from '../ActivityRows.module.css'

export function FullTimelineLink() {
  const openTimeline = useSidebarActivityOpenTimeline()

  return (
    <Link
      as="button"
      inline
      className={clsx(styles.activityRow, 'color-fg-muted py-1 text-small text-left')}
      onClick={event => openTimeline(event.currentTarget)}
    >
      View all activity
    </Link>
  )
}
